export default "__VITE_ASSET__8526c939__"